import React, {FC, FormEvent, useEffect, useRef, useState} from "react";
import {IDropDown as IProps} from "./types";
import cls from '../atoms.module.scss'
import {CustomSelectArrow} from "../../svg";

const DropDown: FC<IProps> = ({
                                  item,
                                  handleChange,
                              }) => {

    const [open, setOpen] = useState(false)
    const [dropDownLabel, setDropDownLabel] = useState(item.attribute_code)
    const rootRef = useRef<any>(null)

    useEffect(() => {
        const handleEvent = (e: MouseEvent) => {
            if (rootRef.current && !rootRef.current.contains(e.target)) {
                setOpen(false)
            }
        }

        document.addEventListener("mousedown", handleEvent)

        return () => document.removeEventListener('mousedown', handleEvent)
    }, [])

    const handleClick = (e: any) => {
        handleChange(e as unknown as FormEvent<HTMLInputElement> , item.validation)
        setDropDownLabel(item.field_options[e.target.id].label)
        setOpen(false)
    }

    return (
        <div className={cls.drop_down} ref={rootRef}>
            <div className={cls.drop_down_btn}
                 onClick={() => setOpen(!open)}
            >
                {dropDownLabel}
                <CustomSelectArrow className={`${cls.drop_down_arrow} ${open && cls.drop_down_opened}`}/>
            </div>

            {open && <div className={cls.drop_down_block}>
                {/*{!(savedFormData as Record<string, string>)?.[item.attribute_code] && (*/}
                {/*    <div*/}
                {/*        id={item?.valueSel ?? ""}*/}
                {/*        className={cls.drop_down_option}*/}
                {/*        onClick={(e) => handleClick(e)}*/}
                {/*    >*/}
                {/*        {item.default_label}*/}
                {/*    </div>*/}
                {/*)}*/}
                {item.field_options.map((option: any, index: any) => {

                    return (
                        <div key={index}
                             id={option.id}
                             className={cls.drop_down_option}
                             onClick={(e) => handleClick(e)}
                        >
                            {option.label}
                        </div>
                    );
                })}
            </div>}
        </div>
    )
}

export default DropDown;